// Auto-generated normalizer for table: CuestionarioRespuestaTextoLibre
export function cuestionarioRespuestaTextoLibreNormalize(row) {
  return {
    idRespuestaTextoLibre: row.idRespuestaTextoLibre ?? row.IdRespuestaTextoLibre ?? row['IdRespuestaTextoLibre'] ?? 0,
    idCuestionarioPreguntas: row.idCuestionarioPreguntas ?? row.IdCuestionarioPreguntas ?? row['IdCuestionarioPreguntas'] ?? 0,
    longitudMaxima: row.longitudMaxima ?? row.LongitudMaxima ?? row['LongitudMaxima'] ?? '',
    palabrasClave: row.palabrasClave ?? row.PalabrasClave ?? row['PalabrasClave'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
